import { MDBBtn, MDBChip, MDBIcon, MDBModalFooter, MDBSpinner } from 'mdb-react-ui-kit'
import React, { forwardRef, useEffect, useRef, useState } from 'react'
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { CreateStreamsTeam, getMisc } from '../../../apiclients/streamsapi_bridge';
import AddToUsersTeam from '../misc/AddToUsersTeam';
import PopupLoaderNew from '../PopupLoaderNew';

const AddSteamsTeam = forwardRef((props, ref) => {
    const { t, i18n } = useTranslation();
    //const [isloading, setIsloading] = useState(false);
    const [teamTypes, setteamTypes] = useState({});
    const [accessibilityList, setaccessibilityList] = useState({});
    const [displayAccessibilities, setDisplayAccessibilities] = useState({});
    const [addUserTeam, setAddUserTeam] = useState(false);
    const addUserToggle = () => setAddUserTeam(!addUserTeam);
    const [teamMembers, setteamMembers] = useState([]);
    const [updateUsers, setUpdateUsers] = useState([]);
    const [isAddedUsers, setIsAddedUsers] = useState(false);
    const [isLoading, setisLoading] = useState(false);
    const addUserRef = useRef(null);

    function handleClick() {
        addUserRef.current.click();
    }

    const { register, handleSubmit, formState: { errors, isDirty }, clearErrors, setError, watch, setValue } = useForm({
        defaultValues: {
            team_name: "",
            type: 3,
            accessibility: 2,
            enable_contributor: false,
            hide_team_members: false,
            add_users: [],

        }
    });


    useEffect(() => {
        if (watch("type")) {
            if (parseInt(watch("type")) === 4) {
                const updatedJSON = removeKeyValuePair(accessibilityList, 1);
                setDisplayAccessibilities(updatedJSON);
                // Check if the current accessibility value is "Automatic" and update it to "Only Admin can Invite"
                if (parseInt(watch("accessibility")) === 1) {
                    setValue("accessibility", 2, { shouldDirty: true });
                }
            } else {
                setDisplayAccessibilities(accessibilityList);
            }
        }
    }, [watch("type")]);

    const removeKeyValuePair = (jsonObject, valueToRemove) => {
        const newObj = { ...jsonObject };
        for (const key in newObj) {
            if (newObj.hasOwnProperty(key) && newObj[key] === valueToRemove) {
                delete newObj[key];
                break; // Assuming the value is unique, so once found and removed, we exit the loop
            }
        }
        return newObj;
    };

    const handleDelete = (extension) => {
        clearErrors("add_users");
        const updateAddPHNum = teamMembers.filter((item) => item.extension !== extension);
        setteamMembers(updateAddPHNum);
        const finalObj = updateAddPHNum.map((user) => ({
            userid: user.userid,
            isadmin: user.isAdmin ? user.isAdmin : false,
        }));
        setValue("add_users", finalObj, { shouldDirty: true });

    };

    useEffect(() => {
        if (updateUsers.length > 0 && isAddedUsers) {
            console.log("update User ::::::::::: " + JSON.stringify(updateUsers));
            const userInfo = updateUsers.map((user) => ({
                userid: user.agentId,
                isadmin: user.isAdmin ? user.isAdmin : false,
            }));
            const userInfoshow = updateUsers.map((user) => ({
                userid: user.agentId,
                isAdmin: user.isAdmin ? user.isAdmin : false,
                username: user.username,
                extension: user.extension,
            }));
            const latestlist = [...(watch("add_users") || []), ...userInfo];
            setValue("add_users", latestlist, { shouldDirty: true });
            //   sendUpdateAPIRequest("add_users", userInfo);
            setteamMembers((prev) => ([...prev, ...userInfoshow]));
            setIsAddedUsers(false);
        }
    }, [updateUsers, isAddedUsers]);



    async function fetchStreamsTeamMisc() {
        try {
            let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
            const params = {
                "misc": [
                    "create_team"
                ],
            };

            const serverResponse = await getMisc(siteid, params);
            if (!serverResponse.ok) {
                console.log("Network response was not ok");
                throw new Error('Network response was not ok');
            }
            else {
                const responseData = await serverResponse.json();
                console.log("Response Data:", JSON.stringify(responseData));
                setteamTypes(responseData?.misc?.streams_teams?.team_types || {});
                setaccessibilityList(responseData?.misc?.streams_teams?.accessibility || {});

                setDisplayAccessibilities(
                    responseData?.misc?.streams_teams?.accessibility || {}
                );
            }


        } catch (error) {
            console.error("[fetchAddLocationMisk] Error:", error);
            // Handle the error, show a user-friendly message or log it.
        }
    }

    useEffect(() => {
        fetchStreamsTeamMisc();
    }, []);

    const onsubmit = async (data) => {
        let updates = {};
        if (isDirty) {
            updates = {
                reqid: 86,
                siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                team_name: data.team_name,
                team_type: data.type,
                accessibility: data.accessibility,
                enable_contributor: data.enable_contributor,
                hide_team_members: data.hide_team_members,
                add_users: data?.add_users ?? null
            };

        }

        console.log("JSON Create Streams team:: " + JSON.stringify(updates));
        props.setIsloading(true);
        let saverep = await CreateStreamsTeam(updates);
        console.log(`reponse of add Streams team: :::: ${JSON.stringify(saverep)}`);
        let saverepeMsg = await saverep.json();
        console.log(`reponse of add Streams team: after:::: ${JSON.stringify(saverepeMsg)}`);
        setTimeout(() => {
            props.setIsloading(false);
        }, 2000);
        if (saverepeMsg.status && saverepeMsg.status == "success") {
            localStorage.setItem("s_message", saverepeMsg.message);
            props.onClose();
            window.location.href = "/streamsteamssection";
        } else {
            if (saverepeMsg.message?.errors) {
                saverepeMsg.message.errors.forEach((err) => {
                    setError(err.param_name, {
                        type: "server",
                        message: err.message,
                    });
                    const fieldElement = document.querySelector(
                        `input[name="${err.param_name}"]`
                    );
                    if (fieldElement) {
                        fieldElement.focus();

                    }
                });
            } else {
                localStorage.setItem("f_message", saverepeMsg.message);
                props.onClose();
                window.location.href = "/streamsteamssection";
            }

        }
    }
    return (
        <>
            <div>
                <div className="tel-numbers">
                    <strong>{t("name")}</strong>
                    <div className="form pt-1">
                        <input
                            maxLength={32}
                            type="text"
                            className="form-control w-100"
                            {...register("team_name", { required: "Name is required" })}
                        />
                        {errors.team_name && (
                            <p className="text-danger">{errors.team_name.message}</p>
                        )}
                    </div>
                </div>

                <div className="w-100 mt-3">
                    <strong className=" d-block">
                        {t("Type")}
                    </strong>
                    <select
                        className="form-select form-control mt-1 w-100"
                        name="Public"
                        // {...register("type")}
                        value={parseInt(watch("type"))}
                        onChange={(e) => setValue("type", parseInt(e.target.value), { shouldDirty: true })}
                    >
                        {Object.entries(teamTypes).map(([value, key]) => (
                            <option key={parseInt(key)} value={parseInt(key)}> {value}</option>
                        ))}
                    </select>
                    {errors.type && (
                        <p className="text-danger">{errors.type.message}</p>
                    )}
                </div>

                <div className="w-100 mt-3">
                    <strong className=" d-block">
                        {t("Accessibility")}
                    </strong>
                    <select
                        className="form-select form-control mt-1 w-100"
                        name="Public"
                        // {...register("accessibility")}
                        value={parseInt(watch("accessibility"))}
                        onChange={(e) => setValue("accessibility", parseInt(e.target.value), { shouldDirty: true })}
                    >
                        {Object.entries(displayAccessibilities).map(([value, key]) => (
                            <option key={parseInt(key)} value={parseInt(key)}> {value}</option>

                        ))}
                    </select>
                    {errors.accessibility && (
                        <p className="text-danger">{errors.accessibility.message}</p>
                    )}
                </div>

                <div className="add-numbermain mt-3">
                    <strong className=" d-block">
                        {t("EnableContributor")}
                    </strong>

                    <div className="phoneselect">
                        <label className="switch">
                            <input className="form-control" {...register("enable_contributor")} type="checkbox" />
                            <span className="slider round"></span>
                        </label>
                    </div>
                </div>

                <div className="add-numbermain mt-1">
                    <strong className=" d-block">
                        {t("HideTeamMembers")}
                    </strong>

                    <div className="phoneselect">
                        <label className="switch">
                            <input className="form-control" {...register("hide_team_members")} type="checkbox" />
                            <span className="slider round"></span>
                        </label>
                    </div>
                </div>
                <div className="add-numbermain">
                    <div className="tel-numbers">{t("AddTeamUser")}</div>
                    <MDBBtn
                        className="mb-2"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            clearErrors("add_users");
                            addUserToggle();
                        }}
                    >
                        <MDBIcon fas icon="plus" size="sm" /> {t("Add User")}
                    </MDBBtn>
                </div>

                <div className="chips chips-placeholder">
                    {teamMembers &&
                        teamMembers.length > 0 &&
                        teamMembers.map((item) => (
                            <>
                                <span>
                                    <MDBChip
                                        className="m-chip d-inline py-2 px-3"
                                        label="Example label"
                                        onDelete={() => handleDelete(item.extension)}
                                        closeIcon={true}
                                        key={item.extension}
                                        size="sm"
                                    >
                                        {item.username} {item.isAdmin ? "(Admin)" : ""}

                                    </MDBChip>
                                </span >
                            </>
                        ))}
                </div >
                {errors?.add_users && (
                    <p className="text-danger text-start">
                        {errors.add_users.message}
                    </p>
                )}
            </div>

            <div style={{ display: "none" }}>
                <button ref={ref} onClick={(e) => { e.preventDefault(); handleSubmit(onsubmit)() }}>
                    {t("add")}</button>
            </div>

            {addUserTeam && (
                <PopupLoaderNew
                    title="Add User"
                    size="lg"
                    content={
                        <>
                            <AddToUsersTeam
                                selectedUsers={teamMembers}
                                sourceUsers={props.sourceUsers}
                                setUpdateUsers={setUpdateUsers}
                                setIsAddedUsers={setIsAddedUsers}
                                onClose={addUserToggle}
                                ref={addUserRef}
                                setIsloading={setisLoading}
                            />
                        </>
                    }
                    onShow={setAddUserTeam}
                    onClose={addUserToggle}
                    onSave={handleClick}
                    isloading={isLoading}
                    flag={1}
                />
            )}

            {/* <MDBModalFooter>
                <MDBBtn color="secondary" onClick={props.onClose}>
                    {t("close")}
                </MDBBtn>
                <MDBBtn onClick={(e) => {
                    e.preventDefault();
                    handleSubmit(onsubmit)();
                }} >{t("add")}</MDBBtn>
            </MDBModalFooter> */}
            {/* {isloading && (
                <>
                    <div className="loadingclass">
                        <MDBBtn disabled>
                            <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                            Loading...
                        </MDBBtn>
                    </div>
                </>
            )} */}

        </>
    )
});

export default AddSteamsTeam
